import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable, from, switchMap, tap } from "rxjs";
import { environment } from "../../../environments/environment";
import {
  AuthResponse,
  LoginCredentials,
  ResetPasswordDto,
} from "../../shared/interfaces/auth.interface";
import { encryptPasswordWithTimestamp } from "../../shared/utils/crypto.utils";
import { clearSession, writeSession } from "../../shared/utils/session.util";

@Injectable({
  providedIn: "root",
})
export class LoginService {
  private http = inject(HttpClient);
  private url = environment.API_DOMAIN + environment.SERVICES.AUTH;

  public login(email: string, password: string): Observable<AuthResponse> {
    return from(this.buildLoginPayload(email, password)).pipe(
      switchMap((payload) =>
        this.http.post<AuthResponse>(`${this.url}/auth/login`, payload).pipe(
          tap((data) => {
            writeSession({ accessToken: data.accessToken, user: data.user });
          })
        )
      )
    );
  }

  public forgotPassword(email: string): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(`${this.url}/auth/forgot-password`, { email });
  }

  public resetPassword(dto: ResetPasswordDto): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(`${this.url}/auth/reset-password`, dto);
  }

  public clearSession(): void {
    clearSession();
  }

  private async buildLoginPayload(email: string, password: string): Promise<LoginCredentials> {
    const timestamp = new Date().getTime();
    const passwordHash = await encryptPasswordWithTimestamp(password, timestamp);
    return { email, password: passwordHash, timestamp };
  }
}
